import { hydratedMeasurementFromJSON, HydratedMeasurementRecord } from "common/records/HydratedMeasurement";
import { currentMeasurementRoofFaces } from "common/selectors/roofFace.selectors";
import { createSelector } from "reselect";
import { currentMeasurement } from "common/selectors/measurement.common.selectors";
import { currentMeasurementWindows } from "common/selectors/window.selectors";
import { currentMeasurementDoors } from "common/selectors/door.selectors";
import { currentMeasurementRooms } from "common/selectors/room.selectors";
/**
 * Rehydrates a measurement with the relationships
 *
 * @param {RootState} state The RootState
 * @param {{ measurementId: number }} props The id of the measurement object
 * @returns {HydratedMeasurementRecord} HydratedMeasurementRecord
 */
export const currentMeasurementHydrated = createSelector(
  [
    currentMeasurement,
    currentMeasurementRoofFaces,
    currentMeasurementWindows,
    currentMeasurementDoors,
    currentMeasurementRooms,
  ],
  (measurement, roofFaces, windows, doors, rooms): HydratedMeasurementRecord => {
    const measurementHydrated = hydratedMeasurementFromJSON(measurement.toJS());
    return measurementHydrated
      .set("roof_faces", roofFaces)
      .set("windows", windows)
      .set("doors", doors)
      .set("rooms", rooms);
  },
);
